import publicRoutes from "./public.route";
import privateRoutes from "./private.route";
import { UserPrivateLayout, UserPublicLayout } from "../../layouts";

export const userRoutes = () => {
  return [
    {
      element: <UserPublicLayout />,
      children: [...publicRoutes()],
    },
    {
      element: <UserPrivateLayout />,
      children: [...privateRoutes()],
    },
  ];
};
